
import { mapState } from 'vuex'
import { SwiperCore } from 'swiper-vue2'
import { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination])
export default {
    middleware: 'checkAuth',
    data() {
        return {
            tab: null,
            page: 1,
            pModel: 0,
            viewPerPage: 2,
            claimableLoading: false,
            rollingRewardLoading: false,
            activeBonusLoading: false,
            endBonusLoading: false,
            claimNowButtonLoading: false,
            code: null,
        }
    },
    computed: {
        ...mapState({
            promotions: (state) =>
                state.themes.promotion.promotions.filter(
                    (el) => el.is_eligible
                ),
            allPromotion: (state) => state.themes.promotion.promotions,
            rollingReward: (state) => state.themes.promotion.rollingReward,
            histories: (state) => state.themes.promotion.histories,
            activePromotion: (state) => state.themes.promotion.activePromotion,
            endPromotion: (state) => state.themes.promotion.endPromotion,
            player: (state) => state.player.player,
        }),
        playerType() {
            return {
                1: this.tl('all'),
                2: this.tl('newPlayer'),
                3: this.tl('regularPlayer'),
            }
        },
    },
    watch: {
        tab(value) {
            if (~~value === 0) {
                if (this.allPromotion.length) return
                this.onFetchClaimablePromotions()
                this.onFetchRollingReward()
            }
            // 1 = active promotion
            if (~~value === 1) {
                if (this.activePromotion.display_name) return
                this.onFetchActivePromotions()
            }
            // 1 = active promotion
            if (~~value === 2) {
                if (this.endPromotion.length) return
                this.onFetchEndedPromotions()
            }
            // 3 = ended promotion
            if (~~value === 3) {
                if (this.histories?.data?.length) return
                this.onFetchHistories()
            }
        },
        page(value) {
            this.onFetchHistories(value)
        },
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    created() {
        const client = process.client
        if (client) {
            // eslint-disable-next-line nuxt/no-globals-in-created
            const wWidth = window.innerWidth
            if (~~wWidth < 660) {
                this.viewPerPage = 1
            } else if (~~wWidth < 950) {
                this.viewPerPage = 2
            } else {
                this.viewPerPage = 3
            }
        } else {
            setTimeout(() => {
                this.getViewPerPage()
            }, 200)
        }
    },
    methods: {
        getViewPerPage() {
            setTimeout(() => {
                const client = process.client
                if (client) {
                    const wWidth = window.innerWidth
                    if (~~wWidth < 660) {
                        this.viewPerPage = 1
                    } else if (~~wWidth < 950) {
                        this.viewPerPage = 2
                    } else {
                        this.viewPerPage = 3
                    }
                } else {
                    setTimeout(() => {
                        this.getViewPerPage()
                    }, 200)
                }
            }, 200)
        },
        onBack() {
            const elParent = document.getElementsByClassName('w-bonus-slider')
            if (!elParent || !elParent[0]) return
            const elBack =
                elParent[0].getElementsByClassName('swiper-button-prev') //
            if (!elBack || !elBack[0]) return
            elBack[0].dispatchEvent(new MouseEvent('click'))
        },
        onNext() {
            const elParent = document.getElementsByClassName('w-bonus-slider')
            if (!elParent || !elParent[0]) return
            const elNext =
                elParent[0].getElementsByClassName('swiper-button-next')
            if (!elNext || !elNext[0]) return
            elNext[0].dispatchEvent(new MouseEvent('click'))
        },
        async onFetchActivePromotions() {
            this.activeBonusLoading = true
            await this.$store.dispatch('themes/promotion/activePromotion')
            this.activeBonusLoading = false
        },
        async onFetchClaimablePromotions() {
            this.claimableLoading = true
            await this.$store.dispatch('themes/promotion/getPromotions')
            this.claimableLoading = false
        },
        async onFetchEndedPromotions() {
            this.endBonusLoading = true
            await this.$store.dispatch('themes/promotion/endPromotion')
            this.endBonusLoading = false
        },
        async onFetchRollingReward() {
            this.rollingRewardLoading = true
            await this.$store.dispatch('themes/promotion/rollingReward')
            this.rollingRewardLoading = false
        },
        async onFetchHistories(page = 1) {
            this.claimableLoading = true
            await this.$store.dispatch('themes/promotion/histories', {
                limit: 10,
                page,
            })
            this.claimableLoading = false
        },
        async claimNowRolling() {
            this.claimNowButtonLoading = true
            const response = await this.$store.dispatch(
                'promotion/claimNowRolling'
            )
            if (response) {
                await this.onFetchRollingReward()
            }
            this.claimNowButtonLoading = false
        },
        claimPromotionFinished(result) {
            if (result) {
                this.tab = 1
            }
        },
        onSlideChange(e) {
            this.pModel = e.realIndex
        },
        onManualSlideChange(idx) {
            if (this.pModel > idx) {
                // Back condition
                const max = this.pModel - idx
                for (let lp = 0; lp < max; lp = lp + 1) {
                    this.onBack()
                }
            } else if (this.pModel < idx) {
                // Next condition
                const max = idx - this.pModel
                for (let lp1 = 0; lp1 < max; lp1 = lp1 + 1) {
                    this.onNext()
                }
            }
            this.pModel = idx
        },
    },
}
